module.exports = __webpack_public_path__ + "static/media/urbangoo.57ac2977.webp";